import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "../../../../components/Layout/Header/Header";
import Footer from "../../../../components/Layout/Footer/Footer";
import ScrollToTop from "../../../../components/Common/ScrollTop";
import OffWrap from "../../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../../components/Common/Breadcumb";
import SearchModal from "../../../../components/Layout/Header/SearchModal";
import footerLogo from "../../../../assets/img/logo/jntua-logo.png";
import { fetchData, imageBaseURL } from "../../../../utils/fetchData";
import Accreditation from "../../../../components/Common/Accreditation";
import { useFontSize } from "../../../../FontSizeContext";
import { getAPIPath, getMenu } from "../../../../utils/getDomainData";

const OTPRI_OrganizationalStructure = () => {
    const [data, setData] = useState([]);
    let location = useLocation();
    const currentDomain = location.pathname.split("/")[1];
    const { fontSize } = useFontSize();

    useEffect(() => {
        fetchData(getAPIPath(currentDomain)?.organizationalStructure, setData);
    }, [currentDomain]);

    const organizationalData = data?.data?.attributes;

    return (
        <React.Fragment>
            <Helmet>
                <title>Organizational Structure | Oil Technological & Pharmaceutical Research Institute | JNTU Anantapur</title>
                <meta
                    name="description"
                    content="Organizational Structure of the Oil Technological and Pharmaceutical Research Institute (OT&PRI) at JNTUA - Learn about our department structure and hierarchy."
                />
                <meta
                    name="keywords"
                    content="OTPRI Organizational Structure, Oil Technological, Pharmaceutical Research Institute, JNTUA, Department Structure, Hierarchy"
                ></meta>
            </Helmet>
            <OffWrap />
            <Header
                parentMenu="home"
                TopBar="enable"
                TopBarClass="topbar-area dark-primary-bg hidden-lg"
            />
            <style>
                {`
                    body,
                    .rs-latest-events.style1 .event-wrap .events-short .date-part .date,
                    .widget ul li a {
                        font-size: ${fontSize}px;
                    }
                    .rs-inner-blog .blog-item .blog-content .blog-title,
                    .widget h1,.content-wrapper h2, .heading, .library-title{
                        font-size: calc(${fontSize}px + 10px);
                    }
                    .breadcrumb-bg .breadcrumbs-text ul li{
                      font-size: calc(${fontSize}px + 2px);
                    }
                    
                    .full-width-header .rs-header .topbar-area .topbar-right li.login-register a,
                    .readon.orange-btn, .rs-latest-events.bg-wrap .notification-filter button,
                    .rs-latest-events.style1 .event-wrap:not(.ls-area) .events-short .slNo, 
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > a,
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > ul li > a,
                    table th, table td {                       
                        font-size: calc(${fontSize}px - 2px);
                    }

                    .rs-footer .footer-top-social .social_msg{
                        font-size: calc(${fontSize}px + 18px);
                    }
                    .rs-footer .footer-center h3{
                        font-size: calc(${fontSize}px + 12px);
                    }
                    .rs-footer.home9-style .footer-top .widget-title,
                    .rs-team.style1 .about-btn--primary,
                    .rs-team.style1 .about-btn--secondary,
                    .course-overview .inner-box h5{
                        font-size: calc(${fontSize}px + 4px);
                    }
                    .rs-footer .footer-center h4,
                    .rightBar h4{
                        font-size: calc(${fontSize}px + 6px);
                    }
                    
                    .organizational-structure-section {
                        background: #fff;
                        padding: 50px 0;
                    }
                    .section-heading {
                        color: #007bff;
                        font-weight: bold;
                        margin-bottom: 40px;
                        border-bottom: 3px solid #007bff;
                        padding-bottom: 10px;
                        display: inline-block;
                        text-align: center;
                        width: 100%;
                    }
                    .gallery-container {
                        padding: 20px 0;
                    }
                    .photo-grid {
                        display: grid;
                        grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
                        gap: 30px;
                        margin-top: 30px;
                    }
                    .photo-item {
                        position: relative;
                        overflow: hidden;
                        border-radius: 15px;
                        box-shadow: 0 10px 30px rgba(0,0,0,0.15);
                        transition: all 0.4s ease;
                        background: #fff;
                    }
                    .photo-item:hover {
                        transform: translateY(-10px) scale(1.02);
                        box-shadow: 0 20px 50px rgba(0,0,0,0.25);
                    }
                    .photo-card {
                        position: relative;
                        overflow: hidden;
                        height: auto;
                        border-radius: 15px;
                    }
                    .photo-card img {
                        width: 100%;
                        height: auto;
                        object-fit: contain;
                        transition: transform 0.4s ease;
                        display: block;
                        max-height: none;
                    }
                    .photo-item:hover .photo-card img {
                        transform: scale(1.1);
                    }
                    .photo-overlay {
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        background: linear-gradient(135deg, rgba(0,123,255,0.8), rgba(40,167,69,0.8));
                        opacity: 0;
                        transition: opacity 0.4s ease;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-radius: 15px;
                    }
                    .photo-item:hover .photo-overlay {
                        opacity: 1;
                    }
                    .overlay-content {
                        text-align: center;
                        color: white;
                        transform: translateY(20px);
                        transition: transform 0.4s ease;
                    }
                    .photo-item:hover .overlay-content {
                        transform: translateY(0);
                    }
                    .overlay-title {
                        font-size: 1.2rem;
                        font-weight: bold;
                        margin-bottom: 10px;
                    }
                    .overlay-text {
                        font-size: 0.9rem;
                        opacity: 0.9;
                    }
                    .photo-info {
                        padding: 20px;
                        background: #fff;
                        border-radius: 0 0 15px 15px;
                    }
                    .photo-name {
                        font-weight: bold;
                        color: #333;
                        margin-bottom: 5px;
                        font-size: 1rem;
                    }
                    .photo-dimensions {
                        color: #666;
                        font-size: 0.85rem;
                        margin-bottom: 5px;
                    }
                    .photo-size {
                        color: #007bff;
                        font-size: 0.8rem;
                        font-weight: 500;
                    }
                    .no-photos {
                        text-align: center;
                        color: #666;
                        font-style: italic;
                        padding: 80px 20px;
                        background: #f8f9fa;
                        border-radius: 15px;
                        margin: 40px 0;
                    }
                    .no-photos h3 {
                        color: #333;
                        margin-bottom: 15px;
                    }
                    .intro-section {
                        background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
                        padding: 40px;
                        border-radius: 15px;
                        margin-bottom: 40px;
                        text-align: center;
                        border: 1px solid #dee2e6;
                    }
                    .intro-title {
                        color: #007bff;
                        font-size: 1.8rem;
                        font-weight: bold;
                        margin-bottom: 20px;
                    }
                    .intro-description {
                        color: #495057;
                        font-size: 1.1rem;
                        line-height: 1.6;
                        max-width: 600px;
                        margin: 0 auto;
                    }
                    .stats-bar {
                        background: #007bff;
                        color: white;
                        padding: 15px 30px;
                        border-radius: 50px;
                        display: inline-block;
                        margin-top: 20px;
                        font-weight: 500;
                    }
                    .lightbox {
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background: rgba(0,0,0,0.9);
                        z-index: 9999;
                        display: none;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                    }
                    .lightbox.active {
                        display: flex;
                    }
                    .lightbox img {
                        max-width: 90%;
                        max-height: 90%;
                        border-radius: 10px;
                        box-shadow: 0 10px 50px rgba(255,255,255,0.1);
                    }
                    .close-lightbox {
                        position: absolute;
                        top: 30px;
                        right: 50px;
                        color: white;
                        font-size: 3rem;
                        cursor: pointer;
                        transition: opacity 0.3s ease;
                    }
                    .close-lightbox:hover {
                        opacity: 0.7;
                    }
                `}
            </style>

            <div className="pageTopOffset">
                {/* breadcrumb-area-start */}
                <SiteBreadcrumb
                    pageTitle="Organizational Structure"
                    pageName="Organizational Structure"
                    breadcrumbsClass="breadcrumb-bg"
                />
                {/* breadcrumb-area-start */}
                {getMenu(currentDomain)}
                
                <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
                    <div className="container">
                        <div className="row">
                            <div className="col pl-20 md-pl-14">
                                <div className="row">
                                    <div className="rs-inner-blog col-lg-12">

                                        {/* Organizational Structure Gallery */}
                                        {organizationalData?.photos && organizationalData.photos.length > 0 ? (
                                            <div className="organizational-structure-section">
                                                <h2 className="section-heading">Organization Structure</h2>
                                                
                                                <div className="gallery-container">
                                                    <div className="photo-grid">
                                                        {organizationalData.photos.map((photoGroup, groupIndex) => (
                                                            photoGroup.media?.data?.map((photo, photoIndex) => (
                                                                <div key={`${groupIndex}-${photoIndex}`} className="photo-item">
                                                                    <div className="photo-card">
                                                                        <img 
                                                                            src={`${imageBaseURL}${photo.attributes.url}`}
                                                                            alt={photo.attributes.alternativeText || `Organizational Structure ${photoIndex + 1}`}
                                                                            loading="lazy"
                                                                            onClick={() => openLightbox(`${imageBaseURL}${photo.attributes.url}`)}
                                                                            style={{cursor: 'pointer'}}
                                                                        />
                                                                        <div className="photo-overlay">
                                                                            <div className="overlay-content">
                                                                                <div className="overlay-title">View Full Size</div>
                                                                                <div className="overlay-text">Click to enlarge</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))
                                                        ))}
                                                    </div>
                                                </div>

                                                {/* Links Section */}
                                                <div className="organizational-structure-section">
                                                    <h4>Links</h4>
                                                    <div className="gallery-container">
                                                        <div className="row">
                                                            <div className="col-lg-3 col-md-4 col-sm-6 mb-3">
                                                                <a href="/otpri/ppt" className="photo-item" style={{textDecoration: 'none', color: 'inherit'}}>
                                                                    <div className="photo-card" style={{height: '120px', backgroundColor: '#f8f9fa', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                                                        <div style={{textAlign: 'center', color: '#007bff'}}>
                                                                            <i className="fas fa-sitemap" style={{fontSize: '2rem', marginBottom: '10px'}}></i>
                                                                            <div style={{fontWeight: 'bold'}}>Structure</div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="photo-info">
                                                                        <div className="photo-name">
                                                                            Organization Structure
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="no-photos">
                                                <h3>Organizational Structure</h3>
                                                <p>Organizational structure diagrams will be updated soon. Please check back later for our comprehensive department hierarchy and administrative structure.</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Lightbox */}
                <div id="lightbox" className="lightbox" onClick="closeLightbox()">
                    <span className="close-lightbox" onClick="closeLightbox()">&times;</span>
                    <img id="lightbox-img" src="" alt="Full size image" />
                </div>
            </div>

            <Accreditation />

            <Footer
                footerClass="rs-footer home9-style main-home"
                footerLogo={footerLogo}
            />

            {/* scrolltop-start */}
            <ScrollToTop scrollClassName="scrollup orange-color" />
            {/* scrolltop-end */}

            <SearchModal />

            {/* Lightbox Script */}
            <script>
                {`
                    function openLightbox(src) {
                        const lightbox = document.getElementById('lightbox');
                        const lightboxImg = document.getElementById('lightbox-img');
                        lightboxImg.src = src;
                        lightbox.classList.add('active');
                        document.body.style.overflow = 'hidden';
                    }

                    function closeLightbox() {
                        const lightbox = document.getElementById('lightbox');
                        lightbox.classList.remove('active');
                        document.body.style.overflow = 'auto';
                    }

                    // Close lightbox on escape key
                    document.addEventListener('keydown', function(e) {
                        if (e.key === 'Escape') {
                            closeLightbox();
                        }
                    });
                `}
            </script>
        </React.Fragment>
    );
};

// Helper functions for lightbox
const openLightbox = (src) => {
    const lightbox = document.getElementById('lightbox');
    const lightboxImg = document.getElementById('lightbox-img');
    if (lightbox && lightboxImg) {
        lightboxImg.src = src;
        lightbox.classList.add('active');
        document.body.style.overflow = 'hidden';
    }
};

const closeLightbox = () => {
    const lightbox = document.getElementById('lightbox');
    if (lightbox) {
        lightbox.classList.remove('active');
        document.body.style.overflow = 'auto';
    }
};

// Make functions globally available
if (typeof window !== 'undefined') {
    window.openLightbox = openLightbox;
    window.closeLightbox = closeLightbox;
}

export default OTPRI_OrganizationalStructure;